var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15106 4.36839V6.46062H8.85028L8.40465 9.33873H6.15106V16.2204H3.06445V9.33873H0.5V6.46062H3.06445V3.56179C3.06529 2.75011 3.38832 1.97196 3.96257 1.39825C4.53682 0.824531 5.31537 0.502164 6.12717 0.501953H9.02486V3.10668H7.4138C7.07898 3.1071 6.75798 3.24038 6.52137 3.47725C6.28477 3.71412 6.15189 4.03521 6.15189 4.36998",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.52483,
    height: 15.72,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebook-dark.80f095e8dcb02e09755cfd2d21c40342.svg";
export { ForwardRef as ReactComponent };